export enum ApplicableFor {
  P2P_ORDER = "P2P_ORDER",
  ROUTES = "ROUTES",
}

export enum Channel {
  SMS = "SMS",
  EMAIL = "EMAIL",
  SLACK = "SLACK",
}

export enum TriggerType {
  ACTION = "ACTION",
  PROGRESS = "PROGRESS",
  GEO = "GEO",
  TIME = "TIME",
}

export enum SendTo {
  DROPOFF_CONTACT = "DROPOFF_CONTACT",
  PICKUP_CONTACT = "PICKUP_CONTACT",
}

export enum ActionTriggerEvent {
  ORDER_CREATED = "ORDER_CREATED",
  ORDER_ASSIGNED = "ORDER_ASSIGNED",
  ORDER_UNASSIGNED = "ORDER_UNASSIGNED",
  PICKUP_IN_PROGRESS = "PICKUP_IN_PROGRESS",
  DROPOFF_IN_PROGRESS = "DROPOFF_IN_PROGRESS",
  ORDER_COMPLETED = "ORDER_COMPLETED",

  ROUTE_ASSIGNED = "ROUTE_ASSIGNED",
  ROUTE_UNASSIGNED = "ROUTE_UNASSIGNED",
  ROUTE_ORDER_STARTED = "ROUTE_ORDER_STARTED",
  ROUTE_COMPLETED = "ROUTE_COMPLETED",

  ORDER_REPORT_CREATED = "ORDER_REPORT_CREATED",
}

export enum RouteProgressTriggerEvent {
  STEPS_BEFORE_ARRIVAL = "STEPS_BEFORE_ARRIVAL",
}

export enum GeoTriggerEvent {
  PICKUP = "PICKUP",
  DROPOFF = "DROPOFF",
  NEARBY = "DRIVER_NEARBY",
}

export enum TimeBasedCondition {
  SPECIFIC_TIME = "SPECIFIC_TIME",
  DELAYED = "DELAYED",
}

export enum TimeBasedDelayedFrom {
  SCHEDULED_START_TIME = "SCHEDULED_START_TIME",
  SCHEDULED_END_TIME = "SCHEDULED_END_TIME",
}

export type ActionTrigger = {
  actionBased: {
    event: ActionTriggerEvent;
  };
};

export type RouteProgressTrigger = {
  routeProgressBased: {
    event: RouteProgressTriggerEvent;
    steps: number;
  };
};

export type GeoTrigger = {
  geoBased: {
    distance: number;
    event: GeoTriggerEvent;
  };
};

export type TimeTrigger = {
  timeBased: {
    condition: TimeBasedCondition;
    delayedFrom: TimeBasedDelayedFrom;
    delayedMinute: number;
    specificTime: string;
  };
};

export type Template = {
  slack: {
    message: string;
  };
  sms: {
    message: string;
  };
};

export type RuleCustomField = {
  fieldId: string;
  values: { value: unknown }[];
};

type BaseNotificationRule = {
  _id?: string;
  applicableFor: ApplicableFor;
  countryCode?: string;
  createdAt?: Date | string;
  createdBy?: string;
  customFields?: RuleCustomField[];
  deletedAt?: Date | string;
  from?: string;
  fromAnyWorkspace?: boolean;
  isActive: boolean;
  ruleName: string;
  sendTo: SendTo | "";
  sendToEmailList?: string[];
  sendToSlackChannel?: string;
  states: string[];
  updatedAt?: Date | string;
  updatedBy?: string;
  workspaceId: string;
};

type BaseRule = BaseNotificationRule & {
  channel: Channel;
  template: Template;
};

export type Rule =
  | (BaseRule & {
      trigger: ActionTrigger;
      triggerType: TriggerType.ACTION;
    })
  | (BaseRule & {
      trigger: GeoTrigger;
      triggerType: TriggerType.GEO;
    })
  | (BaseRule & {
      trigger: RouteProgressTrigger;
      triggerType: TriggerType.PROGRESS;
    })
  | (BaseRule & {
      trigger: TimeTrigger;
      triggerType: TriggerType.TIME;
    });
